export default __webpack_public_path__ + "static/media/coco.f2f13aa9.png";